import "../styles/MainMontronixPage.css";
import "../../../style/GeneralStyle.css";
import "../../../../common/UI/SwitcherButton/styles/switchebutton.css";

import { Link } from "react-router-dom";
import {
  $backButton,
  setGuideMode,
  setOpenModelMon,
  setOpenVideo,
} from "../../../../common/UI/GuideButtons/logic/GuideLogic";
import { useStore } from "effector-react";
import { titleName } from "../../../../common/function";
import { SwitcherButtom } from "../../../../common/UI/SwitcherButton/organoids/switcherbuttom";

import MainPicture from "../../../../common/assets/images/Montronix/Main/ACM_Montronix_logoWithTitle.svg";
import SOZH1 from "../../../../common/assets/images/Montronix/Main/Montronix-Wifi.png";
import SOZH2 from "../../../../common/assets/images/Montronix/Main/Montronix-PulseNG.png";
import SOZH3 from "../../../../common/assets/images/Montronix/Main/Montronix-spectrang.png";
import RECTANGLE from "../../../../common/assets/images/Montronix/Main/Play_White.svg";
import { Tooltip } from "@mui/material";

export interface IForMainModal {
  image: string;
  haveBanner: boolean;
  title: string;
  text: string;
  href: string;
}

export const MainPageMontronix = () => {
  titleName("Montronix");
  const BackButton = useStore($backButton);
  return (
    <>
      <div className="mainFlexMontronix">
        <div className="logoBlockMontronix">
          <img src={MainPicture} alt="" className="logoMontronix" />
        </div>
        <div className="hideMontronix imagesMontronix">
          <div className="imageMontronix-block">
            <div className="imageMontronix-block__up">
              <img
                src={SOZH1}
                alt=""
                className="imageMontronix-block__picture"
              />
              <img
                src={SOZH2}
                alt=""
                className="imageMontronix-block__picture"
              />
            </div>
            <img src={SOZH3} alt="" className="imageMontronix-block__picture" />
          </div>
        </div>
        <Link to="/montronix/photo">
          <Tooltip
            id="button-tooltip"
            title={"к следующей странице"}
            children={
              <img
                src={RECTANGLE}
                className="buttonMontronixNextRun"
                alt=""
                onClick={() => {
                  setGuideMode(false);
                  setOpenVideo(true);
                  setOpenModelMon(false);
                }}
              />
            }
          />
        </Link>
      </div>
      <div className="MainPagePwa_BlockRight_Absolute">
        <SwitcherButtom linkName={"/montronix/photo"} />
      </div>
      <div className="main_BackButton-block">
        <Link to="/">
          <div className={BackButton ? "BackButton_To_GeneralPage" : ""}></div>
        </Link>
      </div>
    </>
  );
};
